<template>
  <transition-group name="list" appear>
    <div v-for="card in displayCards" :key=card.id>
      <div>
        <a v-bind:href="card.link" target="_blank">
          <div class="card">
            <h5>{{ card.contract }}<span class="timestamp">{{ formatTimestamp(card.closed, period) }}</span></h5>
            <span>{{ card.name }}</span>
            <div class="members">{{ members(card) }}</div>
            <div v-if="settings.cards.labels && card.labels" class="card-labels">
              <div v-for="label in card.labels" v-bind:key=label>
                <div class="card-label" :style="{'background-color': labelColor(label)}">{{ label }}</div>
              </div>
            </div>
            <div v-if="settings.global.dots" class="planned-days">
              <div v-for="(n,i) in dots(defaultZero(card.planned_days))" v-bind:key=i>
                <div v-html=n></div>
              </div>
            </div>
            <div v-else class="planned-days">
              {{ defaultZero(card.planned_days) }}
            </div>
            <div v-if="settings.global.dots" class="progress-days">
              <div v-for="(n,i) in dots(defaultZero(card.progress_days))" v-bind:key=i>
                <div v-html=n></div>
              </div>
            </div>
            <div v-else class="progress-days">
              {{ defaultZero(card.progress_days) }}
            </div>
          </div>
        </a>
      </div>
    </div>
  </transition-group>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WorkCards',
  props: [
    'displayCards',
    'period'
  ],
  computed: {
    ...mapGetters([
      'id_token',
      'accounts',
      'settings'
    ])
  },
  methods: {
    formatTimestamp: function (timestamp, period) {
      let date = new Date(timestamp * 1000)
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Octr', 'Nov', 'Dec']
      let weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      let day = date.getDate()
      let weekday = weekdays[date.getDay()]
      let month = months[date.getMonth()]
      let hours = date.getHours()
      let minutes = '0' + date.getMinutes()
      if (period === 'week') {
        return weekday + ' ' + hours + ':' + minutes.substr(-2)
      } else {
        return month + ' ' + day + ', ' + hours + ':' + minutes.substr(-2)
      }
    },
    members: function (card) {
      if ('members' in card) {
        return card.members.join(', ')
      }
      return ''
    },
    dots: function (days) {
      let output = []
      if (days >= 5) {
        let dots = Math.floor(days / 5)
        output.push(...Array(dots).fill('<svg height="6" width="10"><circle cx="3" cy="3" r="3" fill="#f070a1"><title>' + days + '</title></circle></svg>'))
      } else {
        let dots = days
        output.push(...Array(dots).fill('<svg height="6" width="10"><circle cx="3" cy="3" r="3" fill="#77a6f7"><title>' + days + '</title></circle></svg>'))
      }
      return output
    },
    defaultZero: function (value) {
      if (value) {
        return value
      } else {
        return 0
      }
    },
    labelColor: function (text) {
      let red = 0
      let green = 0
      let blue = 0
      let maxBrightness = 192
      for (let i = 0; i < text.length; i++) {
        if (i % 3 === 0) { red = (red + text.charCodeAt(i)) % maxBrightness }
        if (i % 3 === 1) { green = (green + text.charCodeAt(i)) % maxBrightness }
        if (i % 3 === 2) { blue = (blue + text.charCodeAt(i)) % maxBrightness }
      }
      return `rgb(${red}, ${green}, ${blue})`
    }
  }
}
</script>

<style scoped src='../../assets/stylesheet/cards.css'></style>



// WEBPACK FOOTER //
// src/components/Cards/WorkCards.vue